<template>
  <b-modal ref="modal" centered :visible="true" @hidden="onModalHidden" class="tabbed">
    <template slot="modal-header">
      <h1>{{ Translations.sections.boxes.edition.title }}</h1>

      <ul class="nav">
        <li :active="modalState.activeTab=='basic'">
          <a
            @click.prevent="modalState.activeTab='basic'"
          >{{Translations.sections.boxes.edition.tabs.basic.title}}</a>
        </li>
        <!--                <li :active="modalState.activeTab=='constraints'">-->
        <!--                    <a @click.prevent="modalState.activeTab='constraints'">{{Translations.sections.boxes.edition.tabs.constraints.title}}</a>-->
        <!--                </li>-->
      </ul>
    </template>
    <template>
      <WaitingBlock v-if="modalState.isLoadingBox"></WaitingBlock>
      <b-form class="form" v-else>
        <div :class="['tab',{'active' : modalState.activeTab=='basic'}]">
          <input type="hidden" id="stationUid" name="stationUid" v-model="boxData.stationUid" />
          <div class="linked-properties">
            <b-form-group
              id="group-name"
              :label="Translations.labels.name"
              label-for="name"
              :label-cols="4"
            >
              <b-form-input
                id="name"
                name="name"
                v-model="boxData.name"
                type="text"
                required
                autocomplete="off"
                :placeholder="Translations.placeholders.name"
              />
            </b-form-group>
            <b-form-group
              id="color-container"
              :label="Translations.labels.color"
              label-for="colorCode"
              :label-cols="4"
            >
              <b-form-input
                  id="name"
                  name="colorCode"
                  v-model="boxData.colorCode"
                  type="color"
                  :placeholder="Translations.placeholders.color"
              />
            </b-form-group>
              <div >
                <!--                        <span class="detail-label">Style(s)</span>-->
                <b-form-group id="group-style" :label="'Styles'" label-for="style" :label-cols="4">
                  <StyleBadgeList
                      :styles="boxData.styles"
                      ref="styles"
                      :readOnly="true"
                      placeholder
                      @onFocus="onFocus('styles')"
                      @onBlur="onBlur"
                      @click.prevent="openParameterSelector('showStyleSelector','modalStyles', [boxData])"
                  />
                  <!--                        <span class="detail-error">This field is required</span>-->
                </b-form-group>
              </div>
              <div >
                <b-form-group id="group-categories" :label="'Categories'" label-for="categories" :label-cols="4">
                  <!--                        <span class="detail-label">categories</span>-->
                  <StyleBadgeList
                      :styles="boxData.categories"
                      ref="styles"
                      :readOnly="true"
                      placeholder
                      @onFocus="onFocus('categories')"
                      @onBlur="onBlur"
                      @click.prevent="openParameterSelector('showCategoriesSelector','modalCategories', [boxData])"
                  />
                  <!--                        <span class="detail-error">This field is required</span>-->
                </b-form-group>
              </div>
              <div >
                <b-form-group id="group-targets" :label="'Targets'" label-for="targets" :label-cols="4">
                  <!--                        <span class="detail-label">Targets</span>-->
                  <StyleBadgeList styles=""
                      :styles="boxData.targets"
                      ref="styles"
                      :readOnly="true"
                      placeholder
                      @onFocus="onFocus('targets')"
                      @onBlur="onBlur"
                      @click.prevent="openParameterSelector('showTargetSelector','modalTargets', [boxData])"
                  />
                  <!--                        <span class="detail-error">This field is required</span>-->
                </b-form-group>
              </div>
            <b-form-group
              id="artist-repeat-container"
              :label="Translations.labels.artistRepeat"
              label-for="artistRepeat"
              :label-cols="4"
            >
              <b-form-input
                id="artistRepeat"
                name="artistRepeatDelay"
                v-model="boxData.artistRepeatDelay"
                type="number"
                min="0"
                max="1440"
              />
            </b-form-group>
            <b-form-group
              id="track-repeat-container"
              :label="Translations.labels.trackRepeat"
              label-for="trackRepeat"
              :label-cols="4"
              class="mb-3"
            >
              <b-form-input
                id="trackRepeat"
                name="trackRepeatDelay"
                v-model="boxData.trackRepeatDelay"
                type="number"
                min="0"
                max="1440"
              />
            </b-form-group>
          </div>
        </div>
        <!-- <div :class="['tab', {'active' : modalState.activeTab=='constraints'}]">
          <div class="alert alert-warning">Coming soon...</div> -->
          <!--<Button :empty="true" noBorder="true"z><i class="fas fa-plus"></i>&nbsp;Add Constraint</Button>-->
        <!-- </div> -->
      </b-form>
    </template>
    <template slot="modal-footer">
      <Button
        :empty="true"
        class="close-popup"
        @click.prevent="cancelModal"
      >{{ Translations.buttons.cancel }}</Button>
      <Button
        :empty="false"
        class="validate"
        v-if="!modalState.isLoadingBox"
        @click.prevent="editBox"
      >{{ Translations.buttons.doEditBox }}</Button>
    </template>
    <SelectorStyle
        v-show="viewState.showStyleSelector"
        ref="modalStyles"
        :stationUid="boxData.stationUid"
        :noModalEdit="true"
        @newValue="onNewValueStyles"
        @onHidden="resetModalState('showStyleSelector')"
    />
    <SelectorCategories
        v-show="viewState.showCategoriesSelector"
        ref="modalCategories"
        :stationUid="boxData.stationUid"
        :noModalEdit="true"
        @newValueCategories="onNewValueCategories"
        @onHidden="resetModalState('showCategoriesSelector')"
    />
    <SelectorTargets
        v-show="viewState.showTargetSelector"
        ref="modalTargets"
        :stationUid="boxData.stationUid"
        :noModalEdit="true"
        @newValueTargets="onNewValueTargets"
        @onHidden="resetModalState('showTargetSelector')"
    />
  </b-modal>
</template>

<script>
import Button from "@/components/common/Button";
import Bootstrap from "bootstrap-vue";
import store from "@/store";
import router from "@/router";
import Translations from "@/store/translations";
import EventBus from "@/eventbus";
import Portlet from "@/components/common/Portlet.vue";
import { HTTP } from "@/utils/http";
import { mapState } from "vuex";
import WaitingBlock from "@/components/common/WaitingBlock";
import StyleBadgeList from "@/components/common/StyleBadgeList";
import SelectorStyle from "@/components/Library/SelectorStyle";
import SelectorCategories from "@/components/Boxes/SelectorCategorie";
import SelectorTargets from "@/components/Boxes/SelectorTarget";
export default {
  name: "BoxEditionCard",
  store,
  components: { Portlet, Bootstrap, Button, WaitingBlock , StyleBadgeList, SelectorStyle , SelectorCategories , SelectorTargets},
  computed: {
    ...mapState(["currentStation", "editedBox"]),

    Translations: function() {
      return Translations;
    },
    errorMessages: function(inputName) {
      if (this.creationResponse == null || this.creationResponse.errors == null)
        return [];
    }
  },
  props: {
    boxUid: { required: true }
  },
  mounted() {
    this.loadBox();
  },
  watch: {
    "boxData.artistRepeatDelay": function(newV) {
      if (+newV > this.limitHours) {
        this.$nextTick(() => {
          this.boxData.artistRepeatDelay = this.limitHours;
        });
      }
    },
    "boxData.trackRepeatDelay": function(newV) {
      if (+newV > this.limitHours) {
        this.$nextTick(() => {
          this.boxData.trackRepeatDelay = this.limitHours;
        });
      }
    }
  },
  data() {
    return {
      modalState: {
        show: true,
        visible: true,
        activeTab: "basic",
        isLoadingBox: true
      },
      viewState: {
        showStyleSelector: false,
        showCategoriesSelector: false,
        showTargetSelector: false,
      },
      boxData: null,
      creationResponse: null,
      limitHours: 1440
    };
  },
  methods: {
    loadBox() {
      try {
        if (this.currentStation != null && this.boxUid != null) {
          // console.log("Loading box for edition")
          this.modalState.isLoadingBox = true;
          HTTP.get("api/boxes/details", {
            params: { stationUid: this.currentStation.uid, boxUid: this.boxUid }
          })
            .then(this.onBoxLoaded, this.onBoxLoadError)
            .then(this.onBoxLoadComplete);
        } else {
        }
      } catch (e) {
        console.log("loadBox -> error:", e);
      }
    },
    onBoxLoaded(response) {
      this.boxData = response.data.dataItem;
    },
    onBoxLoadError(response) {
      this.boxData = null;
    },
    onBoxLoadComplete(response) {
      this.modalState.isLoadingBox = false;
    },
    editBox() {
     this.boxData.categories = this.TransformDataCategories(this.boxData.categories);
     this.boxData.styles = this.TransformDataStyles(this.boxData.styles);
     this.boxData.targets = this.TransformDataTargets(this.boxData.targets);
      HTTP.post("api/boxes/edit", this.boxData)
        .then(this.onBoxEdited, this.onBoxEditionError)
        .then(function() {
          console.log("End...");
        });
    },
    async onBoxEdited(response) {
      this.creationResponse = response;
      console.log("response from onBoxEdited: ", response.data);
      const { dataItem } = response.data;
      this.$store.commit("onBoxLoaded", dataItem);
      if (this.creationResponse.status === 200) {
        var editedBoxResponse = this.creationResponse.data;
        if (editedBoxResponse != null && editedBoxResponse.dataItem != null) {
          this.$store.dispatch("refreshBoxStats", 
              { stationUid: this.currentStation.uid, boxUid: this.boxUid }
          )
          this.cancelModal();
        }
      } else {
        //let vue build the error messages
      }
      //this.cancelModal();
    },
    onBoxEditionError(response) {
      console.log(response);
      this.creationResponse = response;
      console.error(response);
    },
    cancelModal() {
      this.$refs["modal"].hide();
    },
    onModalHidden() {
      EventBus.$emit("onBoxEditionEnded");
    },
    onFocus(field) {
      this.$set(this.viewState, "fieldFocused", field);
    },
    onBlur() {
      this.$set(this.viewState, "fieldFocused", null);
    },
    openParameterSelector(toggler, selectorName, tracks) {
      if (!tracks || tracks.length === 0) return;
      this.viewState[toggler] = true;

      try {
        var modalSelector = this.$refs[selectorName];

        if (modalSelector) {
          modalSelector.editForTracks(tracks);
        }
      } catch (e) {
        console.log("exc:", e);
      }
    },
    onNewValueTargets(field, value) {
      console.log(field, value);
      this.boxData.targets = value;
    },
    onNewValueCategories(field, value) {
      console.log(field, value);
      this.boxData.categories = value;
    },
    onNewValueStyles(field, value) {
      console.log(field, value);
      this.boxData.styles = value;
    },
    resetModalState(toggler) {

    },
    TransformDataCategories(data){
      if(data) {
        let array = [];
        for (let i = 0; i < data.length; i++) {
          array.push({'categoryId': data[i].id });
        }
        return array;
      }
    },
    TransformDataStyles(data){
      if(data) {
        let array = [];
        for (let i = 0; i < data.length; i++) {
          array.push({'styleId': data[i].id});
        }
        return array;
      }
    },
    TransformDataTargets(data){
      if(data) {
        let array = [];
        for (let i = 0; i < data.length; i++) {
          array.push({'targetId': data[i].id});
        }
        return array;
      }
    },
  }
};
</script>

<style>
</style>
